import { render, staticRenderFns } from "./CalendarIndex.vue?vue&type=template&id=56c97346&scoped=true"
import script from "./CalendarIndex.vue?vue&type=script&lang=js"
export * from "./CalendarIndex.vue?vue&type=script&lang=js"
import style0 from "./CalendarIndex.vue?vue&type=style&index=0&id=56c97346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c97346",
  null
  
)

export default component.exports